
import React from 'react';
import { Trophy, Share } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ActionButtonsProps {
  onViewBadges: () => void;
  onShareProgress: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ onViewBadges, onShareProgress }) => {
  return (
    <div className="mt-4 flex justify-center gap-2">
      <Button 
        variant="outline" 
        size="sm" 
        className="text-hormony-coral border-hormony-coral/30 hover:bg-hormony-coral/10 flex-1"
        onClick={onViewBadges}
      >
        <Trophy size={16} className="mr-1.5" />
        View Badges
      </Button>
      
      <Button 
        variant="outline" 
        size="sm" 
        className="text-hormony-coral border-hormony-coral/30 hover:bg-hormony-coral/10 flex-1"
        onClick={onShareProgress}
      >
        <Share size={16} className="mr-1.5" />
        Share Progress
      </Button>
    </div>
  );
};

export default ActionButtons;
